export default "__VITE_ASSET__BYsYzK70__"